import { type RegistrationCredential, webauthnBeginRegistration, webauthnFinishRegistration } from '@column/api';

import { createPublicKeyCredential } from './client';

export interface PendingPasskeyRegistration {
  challengeId: string;
  credential: RegistrationCredential;
}

export const beginPasskeyRegistration = async (): Promise<PendingPasskeyRegistration> => {
  const { data: registration } = await webauthnBeginRegistration({ throwOnError: true });
  const credential = await createPublicKeyCredential(registration.options);

  return {
    challengeId: registration.challenge_id,
    credential,
  };
};

export const finishPasskeyRegistration = async ({
  displayName,
  registration,
}: {
  displayName: string;
  registration: PendingPasskeyRegistration;
}) => {
  await webauthnFinishRegistration({
    body: {
      challenge_id: registration.challengeId,
      credential: registration.credential,
      display_name: displayName,
    },
    throwOnError: true,
  });
};
